import React, { useEffect, useState } from "react";
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { StldCardPendenciaDeAprovacaoOptions } from "../../styled-components/StyledCardPendenciaDeAprovacaoOptions.style";
import { IconMenuDotsV } from "../../svg";
import { StyledTableDentroDoCard } from "../../styled-components/StyledTableDentroDoCard.style";
import api from '../../services/api';

export const CardOrdensDeServico = (props) => {
    const {
        item,
        getCardId = { getCardId },
        index,
        openModalEdicao,
        loadOrdens
    } = props;

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const [totalHoras, setTotalHoras] = useState(0);
    const [totalValor, settotalValor] = useState(0);

    useEffect(() => {
        let totalHoras = 0;
        let totalValor = 0;
        item.timesheets.forEach((tsItem) => {
            totalHoras += tsItem.totalHorasFaturadas;
            totalValor += tsItem.valorTotalFaturado;
        });
        setTotalHoras(totalHoras);
        settotalValor(totalValor);
    }, [item.Key])


    const cancelar = (item) => {
        Swal.fire({
            text: "Deseja realmente cancelar essa ordem de serviço?",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.showLoading()
                console.log(item)
                try {
                    await api.delete(`OrdemDeServico/${item.ordemServico.idOrdemServico}`);
                    Swal.fire({
                        title: "Sucesso",
                        text: "Ordem de serviço cancelada com sucesso!",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2500,
                    });
                    loadOrdens(null, 0, 10)
                } catch (err) { }
            }
        });
    }

    return (
        <StldCardPendenciaDeAprovacaoOptions className={''}>
            <Flex style={{ display: "initial" }} onMouseOut={() => getCardId(`${index}`)} onMouseOver={() => getCardId(`${index}`)}>
                <Flex.Item className="card-menu-title">
                </Flex.Item>
                <Flex.Item className="card-menu-title-right">
                    <ul id={`${index}`} className="card-menu-hide">
                        {
                            item.ordemServico.status == 'Gerado' &&
                            (<>
                                <li className="menu-card" onClick={() => openModalEdicao(item)}>Editar</li>
                                <li className="menu-card" onClick={() => cancelar(item)}>Cancelar</li>
                            </>)
                        }
                    </ul>
                </Flex.Item>
            </Flex>
            <div className="card-align">
                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text-bold">{item.ordemServico.status} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-time">
                            {item.ordemServico.dataCriacao}
                        </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-title-right">
                        <span>
                            <button className="button-icon" onMouseOut={() => getCardId(`${index}`)} onMouseOver={() => getCardId(`${index}`)}><IconMenuDotsV /></button>
                        </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        {
                            item.ordemServico.dataIntegracao != "" && <span className="legend-title-text" title={item.ordemServico.cliente.nome}> Integrado em: {item.ordemServico.dataIntegracao} </span>
                        }
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        <span className="legend-title-text" title={item.ordemServico.empresa.nome}> {item.ordemServico.empresa.nome} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        <span className="legend-title-text" title={item.ordemServico.cliente.nome}> {item.ordemServico.cliente.nome} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <StyledTableDentroDoCard>
                        <div style={{ fontSize: "13px" }}> Timesheet </div>
                        <div className="table-responsive">
                            <table className="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col" className="text-nowrap">Sigla</th>
                                        <th scope="col">TS</th>
                                        <th scope="col">Segurado</th>
                                        <th scope="col" className="text-nowrap">Total Horas</th>
                                        <th scope="col" className="text-nowrap">Valor Total</th>
                                        <th scope="col" className="text-center">Visualizar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.timesheets.map((tsItem) => {
                                        return (
                                            <tr>
                                                <th className="text-nowrap">{tsItem.sigla}</th>
                                                <td>{tsItem.timeSheetSigla}</td>
                                                <td title={tsItem.segurado.nome}>
                                                    <div className="ellipse-height">
                                                        {tsItem.segurado.nome}
                                                    </div>
                                                </td>
                                                <td className="text-nowrap">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                                <td className="text-nowrap">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                                <td className="text-center">
                                                    <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: tsItem.idTimesheet }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16" style={{ color: "#007bff" }}>
                                                            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                        </svg>
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td className="text-center" colSpan={3}>Total</td>
                                        <td>{formatDecimal(totalHoras)}</td>
                                        <td>{formatCurrency(totalValor)}</td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </StyledTableDentroDoCard>
                </Flex>
            </div>
            {/* <ModalTimesheetFinalizar
                isOpen={modalTimeshetFinalizarIsOpen}
                onRequestClose={closeModalTimesheetFinalizar}
                ariaHideApp={false}
                timesheet={timesheet}
                finalizarResumo={finalizarResumo}
                finalizarResumoAccess={finalizarResumoAccess}
                disableButtons={true}
            >
            </ModalTimesheetFinalizar> */}
        </StldCardPendenciaDeAprovacaoOptions>
    );
};
